import QuestionViewVerbalTime from "./QuestionViewVerbalTime";

export default class QuestionViewVisualTime extends QuestionViewVerbalTime{
    constructor(question) {
        super(question);
        if(question.part !== 2)
        	this._createClocks();
    }

	getHeaderText() {
		const data = P3.assets.json("templates");
		this._answer = this._question.answer;

		let template = this._getTemplate(data);
		let text = template ? template.text : "";
		let words = data.words;

		this._question.timeType =  'string';

		let match = text.match(/\[VALUE([0-9])?]/g);
		if (match){
			if(this.question.part === 1)
				text = text.replace(match, this._question.values[2].toString());
			else{
				text = text.replace(match[0], this._question.values[0].toTime());
				text = text.replace(match[1], this._question.values[1].toTime());
			}
		}

		let genericLocations = this.generateWords(template.text, words.generic_locations, /\[GENERIC_LOCATION([0-9])?]/g);
		for (const i in genericLocations) {
			if (genericLocations.hasOwnProperty(i)) {
				text = text.replace(new RegExp(P3.utils.escape(i), "g"), genericLocations[i]);
			}
		}

		genericLocations = this.generateWords(template.text, words.specific_locations, /\[SPECIFIC_LOCATION([0-9])?]/g);
		for (const i in genericLocations) {
			if (genericLocations.hasOwnProperty(i)) {
				text = text.replace(new RegExp(P3.utils.escape(i), "g"), genericLocations[i]);
			}
		}

		const verb = this.generateWords(template.text, words.verb, /\[VERB([0-9])?]/g);
		for (const i in verb) {
			if (verb.hasOwnProperty(i)) {
				text = text.replace(new RegExp(P3.utils.escape(i), "g"), verb[i]);
			}
		}

		text = this._replaceEnemies(data.words.enemies, text);

		this._clockValues = [];
		this._clockValues.push(this.question.values[this.question.part === 1 ? 0 : 1]);
		if(this.question.part === 2)
			this._clockValues.push(this.question.values[0]);

		return text;
	}

	setAnswer(value) {
		this._inputValue = value;

		if (this._inputField != null)
		{
			if (value) {
				const str = this.question.part === 1 ? value.toTime() : value.toString();
				this._inputField.label.text = str;
				this._inputField.label.style.fontSize = str.length < 5 ? 40 : 20;
			} else {
				this._inputField.label.text = "?";
				this._inputField.label.style.fontSize = 40;
			}
		}
	}

	_setHandPositions(hour, minute, handH, handM){
		let h = 360 / 12;
		let m = 360 / 60;

		handH.rotation = ((h * hour) + ((minute * 360/60)/12)) * PIXI.DEG_TO_RAD;
		handM.rotation = (m * minute) * PIXI.DEG_TO_RAD;
	}

	filterTemplate(x) {
		return x.view === this.question.view && x.part === this.question.part;
	}

	_createClocks(){
    	let container = new PIXI.Container();
		this.addChild(container);

		let tex = P3.assets.texture('clock_face_base');
		let offset = 0;
		for (let i = this._clockValues.length - 1; i >= 0; i--) {
			let clockBG = new PIXI.Sprite(tex);
			clockBG.anchor.set(0, 0.5);
			clockBG.position.set(offset, 340);
			container.addChild(clockBG);

			let hourHand = new PIXI.Sprite(P3.assets.texture('clock_face_shorthand'));
			hourHand.anchor.set(0.5);
			hourHand.scale.set(0.8);
			hourHand.x += clockBG.width * 0.5;
			clockBG.addChild(hourHand);

			let minuteHand = new PIXI.Sprite(P3.assets.texture('clock_face_longhand'));
			minuteHand.anchor.set(0.5);
			minuteHand.scale.set(0.8);
			minuteHand.x += clockBG.width * 0.5;
			clockBG.addChild(minuteHand);

			for (let j = 1; j <= 12; j++) {
				const angleStep = 360 / 12;
				const angle = -180 + (j * angleStep);
				const x = (58 * Math.sin(angle * PIXI.DEG_TO_RAD)) * -1;
				const y = 58 * Math.cos(angle * PIXI.DEG_TO_RAD);

				let t = new PIXI.Text((j).toString(), {
					fontSize: "15px", fontFamily: "Arial", fontWeight: "bold", fill: 0x0});
				t.position.set(x + clockBG.width * 0.5, y);
				t.anchor.set(0.5, 0.5);
				t.resolution = 2;
				clockBG.addChild(t);
			}

			this._setHandPositions(this._clockValues[i].value[0], this._clockValues[i].value[1], hourHand, minuteHand);
			offset += clockBG.width + 30;
		}
		container.x -= container.width * 0.5;// - 35;
	}
}